import { useEffect } from 'react'

import { usePayerInvitations } from '~/hooks/compliance'
import { useAuthUser } from '~/hooks/useAuthUser'
import { useNavigation } from '~/hooks/useNavigation'

/**
 * Hook that checks if the authenticated user has any payee invitations and no orgs.
 * If they do, redirects them to /compliance/accept-invitation.
 *
 * This hook should be used in components where we want to automatically
 * redirect users who have pending payee invitations.
 */
export function usePayeeInvitationRedirect() {
  const { user: authUser, initialLoadingState: isAuthUserLoading } =
    useAuthUser()
  const { data: payerInvitationsData, isLoading: isPayerInvitationsLoading } =
    usePayerInvitations()
  const navigate = useNavigation()

  useEffect(() => {
    if (!authUser || isAuthUserLoading || isPayerInvitationsLoading) return

    const invitations = payerInvitationsData?.invitations || []

    if (authUser.orgs.length === 0 && invitations.length > 0) {
      navigate('/compliance/accept-invitation')
    }
  }, [
    authUser,
    payerInvitationsData,
    isAuthUserLoading,
    isPayerInvitationsLoading,
    navigate,
  ])
}
